<div class="border position-top">
</div>
<div class="border position-bottom">
</div>
<div class="border position-right">
</div>
<div class="border position-left">
</div>
